import { countryCodeToIsoMap } from '../constants/countryCodeToIsoMap'

export function getCountryIsoFromCode(code: string): string {
  return countryCodeToIsoMap[code.toLowerCase()] || 'gb'
}
